import { styled } from '@mui/material/styles';

export const Container = styled('div')(() => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  lineHeight: '4em'
}));

export const Title = styled('span')(({ theme, size }) => ({
  color: theme.color.primary.main,
  fontSize: theme.fontSize[size],
  margin: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  textTransform: 'uppercase'
}));
